// @ts-nocheck
import { Category } from './../../products/domain/Category';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { OverlayPanel } from 'primeng/overlaypanel';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { Product } from 'app/products/domain/product';
import { ICompany } from 'app/shared/Domains/company';
import { IDeliveryContact } from 'app/shared/Domains/deliveryContact';
import { IDeliveryAddress } from 'app/shared/Domains/deliveryAddress';
import { IUser } from 'app/shared/Domains/IUser';
import { IRole } from 'app/shared/Domains/role';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { Configuration } from 'config/config';
import { IProduct } from './domain/IProduct';
import { SaleOrder } from './domain/SaleOrder';
import { IBranch } from 'app/shared/Domains/branch';
import { IMember } from 'app/shared/Domains/member';
import { SoldTo } from 'app/shared/Domains/soldTo';
import { Ingredients } from './domain/Ingredients';
import { LanguageService } from 'app/LanguageService/Language.Service';
import { buildSaleOrderCreatePayload } from 'common/services/sale-order-payload.util';
import { PayLater } from './domain/PayLater';
import { Router } from '@angular/router';
@Component({
  selector: 'app-point-of-sale',
  templateUrl: './point-of-sale.component.html',
  host: { "(window:keyup)": "hotkeys($event)", "(window:click)": "hotClick($event)" },
  styleUrls: ['./point-of-sale.component.css']
})
export class PointOfSaleComponent implements OnInit {
  @ViewChild("rowQuantity", { static: false }) rowQuantityInput!: ElementRef;
  @ViewChild("searchProduct", { static: false }) searchProductInput!: ElementRef;
  @ViewChild("searchMember", { static: false }) searchMemberInput!: ElementRef;
  @ViewChild("op") gridViewData!: OverlayPanel;
  productsInPanel: any[] = [];
  Products: any[] = [];
  selectedProducts: any[] = [];
  loading: boolean = false;
  user!: IUser;
  sourceProducts: any[] = [];
  first: number = 0;
  product!: Product;
  selectProduct!: Product;
  vatTax: number = 0;
  orderProduct: IProduct[] = [];
  newSaleOrder!: SaleOrder;
  isDisableSalesOrder: boolean = false;
  // isDeliveryEnabled: boolean = false;
  towardsCheckOut: boolean = false;
  company!: ICompany;
  role!: IRole;
  saleOrderId!: string;
  mode!: string;
  enterSteps: any[] = [];
  currentStep: any;
  index: number = 0;
  summarySteps: any[] = [];
  summaryStepsWithDelivery: any[] = [];
  summaryCurrentStep: any;
  rowIndex: number = -1;
  keyBuffer: any[] = [];
  deliveryStatusButtonString: string = '';
  branch!: IBranch;
  members: IMember[] = [];
  selectedMember: any;
  membersInPanel: any[] = [];
  memberName: any;
  showExtraIngredients: boolean = false;
  ingredients: Ingredients[] = [];
  defaultIngredients: any[] = [];
  extraIngredientsDialogVisibility: boolean = false;
  paymentOptions: any[] = [];
  settlePaymentOptions: any[] = [];
  totalIngredients: Ingredients[] = [];
  areIngredientsEnough = true;
  areIngredientsEnoughArray: boolean[] = [];
  minValue: number = 0;
  individualMax: any;
  paymentMode: any;
  invoiceMessage: any;
  remainingBalance: number = 0;
  payRemainingBalance: number = 0;
  taxType :string = '';
  taxRate: number = 0;
  hideTaxInfo: boolean = false;
  paymentModeTaxPos: boolean = false;
  isDiscountFormulaReverse: boolean = false;
  orderStatus: string = '';
  isQuotation: boolean = false;
  buyerType: 'WalkIn' | 'Customer' | 'Employee' | null = 'WalkIn';
  buyerTypeOptions: { label: string; value: string }[] = [
    { label: 'Walk-in Customer', value: 'WalkIn' },
    { label: 'Customer', value: 'Customer' },
    { label: 'Employee', value: 'Employee' },
  ];
  employees: IUser[] = [];
  employeesInPanel: IUser[] = [];
  selectedEmployee!: IUser;
  buyerSearchText: string = '';
  confirmationMessage = '';
  private pendingConfirmationAction: (() => void) | null = null;

  constructor(
    private LanguageService: LanguageService,
    private appServiceManager: AppServiceManager,
    private messageService: MessageService,
    public config: Configuration,
    private route: ActivatedRoute,
    private breadcrumbService: BreadcrumbService,
    private router: Router,
  ) {
    route.params.subscribe((params) => {
      this.saleOrderId = params["id"];
      if (this.saleOrderId === null || this.saleOrderId === undefined) {
        this.mode = 'add';
      }
      this.breadcrumbService.setItems([
        { label: "Sales", routerLink: ["/sale-orders"] },
        { label: "Sale-Order" },
      ]);
    });
  }
	setLabel(label: string) {
    return this.LanguageService.GetCurrentLanguage("PointOfSaleComponent", label);
  }
  ngOnInit() {
    this.InitObjects();
    this.user = AuthService.getLoggedInUser();
    this.role = AuthService.getLoggedInRole();
    if (this.saleOrderId) {
      this.getSaleOrderById();
    }
    // Refresh productImagePath from localStorage
    this.config.productImagePath = localStorage?.getItem('productImagePath');
    this.getCompany();
    this.getMembers();
    this.getEmployees();
    this.showExtraIngredients = false;
    this.productsInPanel = [];
    this.membersInPanel = [];
    this.Products = [];
    this.selectedProducts = [];
    this.getProducts();
    this.product = new Product();
    this.selectProduct = new Product();
    this.company = new ICompany();
    this.vatTax = 5;
    this.orderProduct = [];
    this.newSaleOrder.discount = 0;
    this.newSaleOrder.isDeliveryEnabled = false;
    this.sum();
    this.paymentOptions = [
      { label: 'Cash - Reception', value: 'Cash-Reception' },
      { label: 'Pay Later', value: 'Pay-Later' },
    ];
    this.getBranch();
    this.paymentMode = "Cash-Reception";
    this.updateSettlePaymentOptions();
    this.currentStep = 0;
    this.summaryCurrentStep = 0;
    this.summarySteps = [
      "overallDiscount",
      "paymentReceived",
      "checkoutButton"
    ];
    this.summaryStepsWithDelivery = [
      "overallDiscount",
      "deliveryFirstName",
      "deliveryLastName",
      "deliveryEmail",
      "deliveryPhone",
      "deliveryAddress",
      "deliveryCity",
      "deliveryState",
      "deliveryZIPCode",
      "paymentReceived",
      "checkoutDeliveryButton"
    ];
  }

  InitObjects() {
    this.newSaleOrder = new SaleOrder();
    this.newSaleOrder.deliveryContactDetails = new IDeliveryContact();
    this.newSaleOrder.deliveryContactDetails.deliveryAddress = new IDeliveryAddress();
    this.newSaleOrder.soldTo = new SoldTo();
    this.newSaleOrder.soldTo.name = "Walk in Customer";
    this.newSaleOrder.soldTo.type = 'WalkIn';
    this.newSaleOrder.modeOfPayment = "Cash-Reception";
    this.memberName = "Walk in Customer";
    this.buyerType = 'WalkIn';
  }

  initializeIngredientsEnoughArray(): void {
    this.areIngredientsEnoughArray = Array.from({ length: this.ingredients.length }, () => true);
  }

  updateSettlePaymentOptions() {
    this.settlePaymentOptions = (this.paymentOptions || []).filter(o => o.value !== 'Pay-Later');
  }

  getMembers() {
    this.members = [];
    this.loading = true;
    this.appServiceManager.get('branches/' + this.user.branch + '/customers/actions/short').subscribe((res: IMember[]) => {
      if (res.length > 0) {
        this.members = res;
        this.membersInPanel = res;
        this.loading = false;
      } else {
        this.loading = false;
        this.members = [];
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Members Found' });
      }
    },
      (error) => {
        // this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error.error.message, });
      });
  }

  getEmployees() {
    this.employees = [];
    const branchId = AuthService.getLoggedInBranch() || this.user.branch;
    this.appServiceManager.get(`branches/${branchId}/users/actions/search`).subscribe((res: IUser[]) => {
      let users = res || [];
      if (this.role?.name !== 'Super Admin') {
        users = users.filter((u: any) => u.userRole?.name !== 'Super Admin');
      }
      this.employees = users.filter(u => u.name?.toLowerCase() !== 'tecgym admin');
      this.employeesInPanel = [...this.employees];
    },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error.error?.message || error });
      });
  }

  getSaleOrderById() {
    const branchId = AuthService.getLoggedInBranch() || this.user?.branch;
    if (!branchId || !this.saleOrderId) {
      return;
    }
    this.loading = true;
    this.appServiceManager.get(`branches/${branchId}/sale-orders/${this.saleOrderId}`).subscribe(
      data => {
        this.newSaleOrder = data;
        this.mode = 'edit';
        this.orderProduct = this.newSaleOrder.products;
        this.orderStatus = this.newSaleOrder.orderStatus;
        if (this.newSaleOrder.payLater || String(this.newSaleOrder.orderStatus || '').toLowerCase() === 'paylater') {
          this.normalizePayLaterFromOrder();
          this.payRemainingBalance = this.getPayLaterAmountDue();
          this.paymentMode = 'Cash-Reception';
          this.newSaleOrder.returned = 0;
          this.remainingBalance = 0;
          if (this.newSaleOrder.payLater?.buyerType === 'Customer') {
            this.buyerType = 'Customer';
          } else if (this.newSaleOrder.payLater?.buyerType === 'Employee') {
            this.buyerType = 'Employee';
          }
        } else {
          this.remainingBalance = this.newSaleOrder.remainingBalance;
          this.payRemainingBalance = this.newSaleOrder.remainingBalance;
          this.remainingBalance = 0;
        }
        if (this.newSaleOrder.status == 'POS') {
          this.newSaleOrder.isDeliveryEnabled = false;
          this.newSaleOrder.deliveryContactDetails = new IDeliveryContact();
          this.newSaleOrder.deliveryContactDetails.deliveryAddress = new IDeliveryAddress();

        } else {
          this.newSaleOrder.isDeliveryEnabled = true;
          if (this.newSaleOrder.status == 'REQUESTED') {
            this.deliveryStatusButtonString = "Confirm Order";
          } else if (this.newSaleOrder.status == 'CONFIRMED') {
            this.deliveryStatusButtonString = "Confirm Ready to Shipped";
          } else if (this.newSaleOrder.status == 'READY_TO_SHIPPED') {
            this.deliveryStatusButtonString = "Confirm Shipped";
          } else if (this.newSaleOrder.status == 'SHIPPED') {
            this.deliveryStatusButtonString = "Confirm Delivered";
          } else if (this.newSaleOrder.status == 'DELIVERED') {
            this.deliveryStatusButtonString = "Delivered";
          }
        }
        // Final Sold To display — never keep Walk in when a real buyer exists
        this.memberName = this.resolveBuyerName();
        if (!this.newSaleOrder.soldTo) {
          this.newSaleOrder.soldTo = new SoldTo();
        }
        this.newSaleOrder.soldTo.name = this.memberName;
        const buyerType = this.resolveBuyerType();
        if (buyerType && buyerType !== 'WalkIn') {
          this.newSaleOrder.soldTo.type = buyerType as 'Customer' | 'Employee';
        }
        this.loading = false;
        // let suppliers = [];
        // suppliers.push(this.newPurchaseOrder.supplier);
        // this.selectedSupplier = suppliers;
        // this.orderProduct = this.newPurchaseOrder.products;
        // if (this.newPurchaseOrder.status != undefined && this.newPurchaseOrder.status == 'FULFILLED') {
        //   this.isFulFil = true;
        //   this.fulFilButtonName = "FulFilled";

        // } else {
        //   this.isFulFil = false;
        //   this.fulFilButtonName = "FulFil";

        // }
      },
      error => {
        this.loading = false;
        alert(error);
      }
    );
  }

  getCompany() {
    this.company = AuthService.getLoggedInCompanyBranch();
    if(!this.company){
    this.appServiceManager.get("companies/current").subscribe(
      (res) => {
        if (res) {
          this.company = res;
        } else {
          this.company = new ICompany();
          this.messageService.clear();
          this.messageService.add({
            severity: "info",
            summary: "Info Message",
            detail: "Something Went Wrong",
          });
        }
      },
      (error) => {
        this.company = new ICompany();
        this.messageService.clear();
        this.messageService.add({
          severity: "error",
          summary: "Error Message",
          detail: error,
        });
      }
    );
  }
}
  getBranch() {
        this.branch = AuthService.getLoggedInCurrentBranch();
        if(this.branch){
            const branchPayments = Array.isArray(this.branch.payments) ? this.branch.payments : [];
            if (branchPayments.length > 0) {
                branchPayments.forEach(payment => {
                    const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
                    if (!existingBank) {
                        this.paymentOptions.push({
                            label: `${payment.type} - ${payment.name}`,
                            value: `${payment.type}-${payment.name}`
                        });
                    }
                });
                const lastPayment = branchPayments[branchPayments.length - 1];
                this.taxType = lastPayment.taxSettings.taxCalculationType;
                this.taxRate = lastPayment.taxSettings.taxRate;
                const paymentModes = branchPayments.filter(x => x.taxSettings.taxCalculationType == "NO_TAX");
                if(paymentModes.length == branchPayments.length) {
                    this.hideTaxInfo = true;
                }
            }
            this.paymentModeTaxPos = this.branch.permissions?.paymentModeTaxPos || false
            this.isDiscountFormulaReverse = this.branch.permissions?.isDiscountFormulaReverse || false
            this.updateSettlePaymentOptions();
        }
        if(!this.branch){

            this.appServiceManager.get('branches/' + this.user.branch).subscribe((res) => {
              if (res) {
                this.branch = res;
                const branchPayments = Array.isArray(res.payments) ? res.payments : [];
                branchPayments.forEach(payment => {
                    const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
                    if (!existingBank) {
                        this.paymentOptions.push({
                            label: `${payment.type} - ${payment.name}`,
                            value: `${payment.type}-${payment.name}`
                        });
                    }
                });
                if (branchPayments.length > 0) {
                  const lastPayment = branchPayments[branchPayments.length - 1];
                  this.taxType = lastPayment.taxSettings.taxCalculationType;
                  this.taxRate = lastPayment.taxSettings.taxRate;
                }
                const paymentModes = branchPayments.filter(x => x.taxSettings.taxCalculationType == "NO_TAX");
                if(paymentModes.length == branchPayments.length) {
                  this.hideTaxInfo = true;
                }
                this.updateSettlePaymentOptions();
              } else {
                this.branch = new IBranch();
                this.messageService.clear();
                this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
              }
            },
              (error) => {
                this.branch = new IBranch();
                this.messageService.clear();
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
            });
        }
        this.invoiceMessage = this.branch.invoiceData?.invoiceMessage || '';
    }

  private loggedInRoleName(): string {
    const fromRole = this.role?.name;
    if (typeof fromRole === 'string' && fromRole.trim()) {
      return fromRole.trim();
    }
    const fromUser = this.user?.role;
    if (typeof fromUser === 'string' && fromUser.trim()) {
      return fromUser.trim();
    }
    if (fromUser?.name) {
      return String(fromUser.name).trim();
    }
    return '';
  }

  private productRoleName(product: any): string {
    const role = product?.role;
    if (!role) {
      return '';
    }
    if (typeof role === 'string') {
      return role.trim();
    }
    return String(role.value || role.name || '').trim();
  }

  private productsVisibleForLoggedInRole(products: any[]): any[] {
    const loggedInRole = this.loggedInRoleName().toLowerCase();
    if (loggedInRole === 'admin' || loggedInRole === 'super admin') {
      return products;
    }
    return products.filter((product) => {
      const productRole = this.productRoleName(product).toLowerCase();
      return !!productRole && productRole === loggedInRole;
    });
  }

  getProducts() {
    this.loading = true;
    this.appServiceManager.get(`branches/${this.user.branch}/products`).subscribe((res: any) => {
      if (res.length > 0) {
        this.productsInPanel = res;
        this.sourceProducts = res;
        this.Products = res;
        this.defaultIngredients = res
          .filter(x => x.type === "Ingredients")
          .map(x => ({ code: x.code, totalQuantity: x.totalQuantity }));
        console.log('default', this.defaultIngredients);
        const visibleProducts = this.productsVisibleForLoggedInRole(res);
        this.productsInPanel = visibleProducts;
        this.sourceProducts = visibleProducts;
        this.Products = visibleProducts;
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No product Found' });
      }
      this.loading = false;
    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }
  private calculateTax(  baseAmount: number,  discount: number,  taxRate: number,  taxType: string,  isDiscountFormulaReverse: boolean,  paymentModeTaxPos: boolean,  productVatTaxTotal: number = 0) {
  let taxableAmount = isDiscountFormulaReverse ? baseAmount : (baseAmount - discount);
  taxableAmount = Math.max(taxableAmount, 0);

  if (baseAmount === discount && isDiscountFormulaReverse) {
    return { total: taxableAmount, tax: 0 };
  }

  let tax = 0;

  if (paymentModeTaxPos) {
    if (taxType == "WITH_TAX") {
      tax = parseFloat(((taxableAmount * taxRate) / 100).toFixed(2));
    }

    return {total: taxType == "WITH_TAX" ? taxableAmount + tax : taxableAmount, tax };
  }

  tax = parseFloat((productVatTaxTotal || 0).toFixed(2));

  return {total: taxableAmount + tax, tax};
}


  onPaymentModeChange(value: string) {
    this.paymentMode = value;
    if (value === 'Pay-Later') {
      this.newSaleOrder.paid = 0;
      this.remainingBalance = 0;
      this.newSaleOrder.returned = 0;
    }
    const extractedValue = value.split("-")[1];
        if (Array.isArray(this.branch.payments)) {
            this.branch.payments.forEach(payment => {
                if (payment.name == extractedValue) {
                    this.taxType=payment.taxSettings.taxCalculationType;
                    this.taxRate=payment.taxSettings.taxRate;
                }
            });
        }
    this.newSaleOrder.modeOfPayment = this.paymentMode;
    this.sum();
  }

  resetSoldTo() {
    this.memberName = "Walk in Customer";
    this.newSaleOrder.soldTo = new SoldTo();
    this.selectedMember = undefined;
    this.selectedEmployee = undefined;
    this.buyerSearchText = '';
    if (this.buyerType === 'WalkIn') {
      this.newSaleOrder.soldTo.name = "Walk in Customer";
      this.newSaleOrder.soldTo.type = 'WalkIn';
      this.memberName = "Walk in Customer";
    }
  }

  onBuyerTypeChange() {
    this.resetSoldTo();
    if (this.buyerType === 'Customer') {
      this.membersInPanel = [...this.members];
    } else if (this.buyerType === 'Employee') {
      this.employeesInPanel = [...this.employees];
    }
    if (this.buyerType === 'WalkIn' && this.paymentMode === 'Pay-Later') {
      this.onPaymentModeChange('Cash-Reception');
    }
  }

  getCreatePaymentOptions() {
    if (this.buyerType === 'WalkIn') {
      return (this.paymentOptions || []).filter(o => o.value !== 'Pay-Later');
    }
    return this.paymentOptions;
  }

  isBuyerSelected(): boolean {
    if (!this.buyerType) {
      return false;
    }
    if (this.buyerType === 'WalkIn') {
      return true;
    }
    if (this.buyerType === 'Customer') {
      return !!this.selectedMember;
    }
    if (this.buyerType === 'Employee') {
      return !!this.selectedEmployee;
    }
    return false;
  }

  isPayLaterMode(): boolean {
    return this.paymentMode === 'Pay-Later';
  }

  hasOpenPayLater(): boolean {
    const pl = this.newSaleOrder?.payLater;
    const status = String(this.newSaleOrder?.orderStatus || '').toLowerCase();
    if (!pl && status !== 'paylater') return false;
    if (status === 'fulfilled') return false;
    const paid = Number(this.newSaleOrder.paid) || 0;
    const due = this.getPayLaterAmountDue();
    return due > 0 && paid < due;
  }

  getPayLaterAmountDue(): number {
    return Number(this.newSaleOrder?.payLater?.amount) || Number(this.newSaleOrder?.total) || 0;
  }

  getPayLaterBuyerDisplay(): string {
    const name = this.resolveBuyerName();
    const type = this.resolveBuyerType();
    if (name && type && type !== 'WalkIn') {
      return `${name} (${type})`;
    }
    return name || '';
  }

  private isWalkInName(name: string): boolean {
    const n = (name || '').toString().trim().toLowerCase();
    return !n || n === 'walk in customer' || n === 'walk-in customer' || n === 'walkin customer';
  }

  resolveBuyerName(): string {
    const order: any = this.newSaleOrder || {};
    const pl: any = order.payLater || {};
    const soldTo: any = order.soldTo || {};
    const candidates = [
      pl.buyerName,
      pl.name,
      pl.customerName,
      pl.employeeName,
      pl.buyer?.name,
      pl.customer?.name,
      pl.employee?.name,
      soldTo.name,
      order.buyerName,
      this.memberName,
    ];
    for (const c of candidates) {
      const name = (c == null ? '' : String(c)).trim();
      if (!this.isWalkInName(name)) {
        return name;
      }
    }
    return 'Walk in Customer';
  }

  resolveBuyerType(): string {
    const order: any = this.newSaleOrder || {};
    const pl: any = order.payLater || {};
    const soldTo: any = order.soldTo || {};
    const candidates = [
      pl.buyerType,
      pl.type,
      pl.buyer_type,
      pl.buyer?.type,
      soldTo.type,
    ];
    for (const c of candidates) {
      const type = (c == null ? '' : String(c)).trim();
      if (type && type !== 'WalkIn') {
        return type;
      }
    }
    return soldTo.type || '';
  }

  resolveBuyerNumber(): string {
    const order: any = this.newSaleOrder || {};
    const pl: any = order.payLater || {};
    const soldTo: any = order.soldTo || {};
    const type = this.resolveBuyerType();
    if (type !== 'Customer' && type !== 'Employee') {
      return '';
    }
    return this.extractPhone(soldTo)
      || this.extractPhone(pl)
      || this.extractPhone(this.selectedMember)
      || this.extractPhone(this.selectedEmployee)
      || this.extractPhone(this.members?.find(m => m._id === soldTo?._id || m._id === pl?.buyerId))
      || this.extractPhone(this.employees?.find(e => e._id === soldTo?._id || e._id === pl?.buyerId))
      || '';
  }

  private extractPhone(source: any): string {
    if (!source) {
      return '';
    }
    const candidates = [
      source.phone,
      source.mobile,
      source.contact,
      source.contactDetail?.contact,
      source.contactDetails?.contact,
    ];
    for (const c of candidates) {
      const value = (c == null ? '' : String(c)).trim();
      if (value) {
        return value;
      }
    }
    return '';
  }

  normalizePayLaterFromOrder() {
    if (!this.newSaleOrder.payLater) {
      this.newSaleOrder.payLater = new PayLater();
    }
    const pl = this.newSaleOrder.payLater as any;
    if (!this.newSaleOrder.soldTo) {
      this.newSaleOrder.soldTo = new SoldTo();
    }
    const soldTo = this.newSaleOrder.soldTo;

    // Support alternate / nested API field names
    if (!pl.buyerName) {
      pl.buyerName = pl.name || pl.customerName || pl.employeeName ||
        pl.buyer?.name || pl.customer?.name || pl.employee?.name || null;
    }
    if (!pl.buyerType) {
      pl.buyerType = pl.type || pl.buyer_type || pl.buyer?.type || null;
    }
    if (!pl.buyerId) {
      pl.buyerId = pl.customerId || pl.employeeId || pl.userId ||
        pl.buyer?._id || pl.buyer?.id || pl.customer?._id || null;
    }

    if (pl.amount == null || Number(pl.amount) === 0) {
      pl.amount = Number(this.newSaleOrder.total) || 0;
    }
    if (this.isWalkInName(pl.buyerName) && !this.isWalkInName(soldTo?.name)) {
      pl.buyerName = soldTo.name;
    }
    if (!pl.buyerType && soldTo?.type && soldTo.type !== 'WalkIn') {
      pl.buyerType = soldTo.type;
    }
    if (!pl.buyerId && soldTo?._id) {
      pl.buyerId = soldTo._id;
    }
    if (!pl.tagNumber && soldTo?.tagNumber) {
      pl.tagNumber = soldTo.tagNumber;
    }
    if (!pl.employeeCode && soldTo?.employeeCode) {
      pl.employeeCode = soldTo.employeeCode;
    }

    const buyerName = this.resolveBuyerName();
    const buyerType = this.resolveBuyerType();

    // Always put real buyer name in Sold To (never keep Walk in when buyer exists)
    if (!this.isWalkInName(buyerName)) {
      soldTo.name = buyerName;
      pl.buyerName = buyerName;
      if (buyerType && buyerType !== 'WalkIn') {
        soldTo.type = buyerType as 'Customer' | 'Employee';
        pl.buyerType = buyerType;
      }
      if (pl.buyerId) {
        soldTo._id = pl.buyerId;
      }
      if (pl.tagNumber) {
        soldTo.tagNumber = pl.tagNumber;
      }
      if (pl.employeeCode != null && pl.employeeCode !== '') {
        soldTo.employeeCode = String(pl.employeeCode);
      }
    }
    this.memberName = soldTo.name || buyerName;
  }

  getSelectedBuyer(): IMember | IUser | undefined {
    if (this.buyerType === 'Employee') {
      return this.selectedEmployee;
    }
    if (this.buyerType === 'Customer') {
      return this.selectedMember;
    }
    return undefined;
  }

  buildPayLaterObject(): PayLater {
    const buyer = this.getSelectedBuyer();
    const payLater = new PayLater();
    payLater.amount = this.newSaleOrder.total;
    payLater.buyerType = this.buyerType as 'Customer' | 'Employee';
    if (!buyer) {
      return payLater;
    }
    payLater.buyerId = buyer._id;
    payLater.buyerName = buyer.name;
    if (this.buyerType === 'Customer') {
      payLater.tagNumber = (buyer as IMember).tagNumber;
    } else {
      payLater.employeeCode = (buyer as IUser).userCode;
    }
    return payLater;
  }

  applySoldToFromBuyer() {
    if (this.buyerType === 'WalkIn') {
      if (!this.newSaleOrder.soldTo) {
        this.newSaleOrder.soldTo = new SoldTo();
      }
      this.newSaleOrder.soldTo.name = "Walk in Customer";
      this.newSaleOrder.soldTo.type = 'WalkIn';
      this.newSaleOrder.soldTo._id = '';
      this.newSaleOrder.soldTo.tagNumber = '';
      this.newSaleOrder.soldTo.employeeCode = '';
      return;
    }
    const buyer = this.getSelectedBuyer();
    if (!buyer) {
      return;
    }
    if (!this.newSaleOrder.soldTo) {
      this.newSaleOrder.soldTo = new SoldTo();
    }
    this.newSaleOrder.soldTo._id = buyer._id;
    this.newSaleOrder.soldTo.name = buyer.name;
    this.newSaleOrder.soldTo.type = this.buyerType as 'Customer' | 'Employee';
    if (this.buyerType === 'Customer') {
      this.newSaleOrder.soldTo.tagNumber = (buyer as IMember).tagNumber;
      this.newSaleOrder.soldTo.employeeCode = undefined;
    } else {
      this.newSaleOrder.soldTo.employeeCode = (buyer as IUser).userCode;
      this.newSaleOrder.soldTo.tagNumber = undefined;
    }
  }

  searchPanelProducts(event, value, type) {
    if (!(event.keyCode == 40 || event.keyCode == 38)) {
      let matchedName = [];
      if (value !== null && value !== undefined && value.toString().length > 0) {
        if (value == "") {
          this.productsInPanel = Object.assign([], this.sourceProducts);
        }
        if (!value) {
          this.productsInPanel = Object.assign([], this.sourceProducts);
        }
        if (value != "") {

          if (type === "name") {
            matchedName = Object.assign([], this.sourceProducts).filter(
              cust => (cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null) || (cust.barcode ? cust.barcode.indexOf(value) > -1 : null));
          }

          const distinct = (value, index, self) => {
            return self.indexOf(value) === index;
          }
          const source = matchedName;
          this.productsInPanel = source.filter(distinct);

          // let panal: any = document.getElementById("op");
          // let data = this.productsInPanel[0];
          // this.onProductRowSelect({data}, panal)

          if (this.productsInPanel.length === 0) {
            this.productsInPanel = [];
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Products Found' });
          } else {
            this.first = 0;
            this.rowIndex = -1;
            if (this.productsInPanel.length === 1) {
              this.first = 0;
              this.rowIndex = -1;
            }
            this.productsInPanel = [...this.productsInPanel];
          }
        }
      } else {
        this.productsInPanel = Object.assign([], this.sourceProducts);
        this.productsInPanel = [...this.productsInPanel];
      }
    }

  }
  searchPanelMember(event, value, type) {
    if (!(event.keyCode == 40 || event.keyCode == 38)) {
      let matchedName = [];
      if (value !== null && value !== undefined && value.toString().length > 0) {
        if (value == "") {
          this.membersInPanel = Object.assign([], this.members);
        }
        if (!value) {
          this.membersInPanel = Object.assign([], this.members);
        }
        if (value != "") {

          if (type === "name") {
            matchedName = Object.assign([], this.members).filter(
              cust => (cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null) || (cust.tagNumber ? cust.tagNumber.indexOf(value) > -1 : null));
          }

          const distinct = (value, index, self) => {
            return self.indexOf(value) === index;
          }
          const source = matchedName;
          this.membersInPanel = source.filter(distinct);

          // let panal: any = document.getElementById("op");
          // let data = this.membersInPanel[0];
          // this.onProductRowSelect({data}, panal)

          if (this.membersInPanel.length === 0) {
            this.membersInPanel = [];
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Members Found' });
          } else {
            this.first = 0;
            this.rowIndex = -1;
            if (this.membersInPanel.length === 1) {
              this.first = 0;
              this.rowIndex = -1;
            }
            this.membersInPanel = [...this.membersInPanel];
          }
        }
      } else {
        this.membersInPanel = Object.assign([], this.members);
        this.membersInPanel = [...this.membersInPanel];
      }
    }

  }

  onPageChange(event) {
    this.first = event.first;
  }

  getProductImageUrl(imagePath: string): string {
    if (!imagePath) {
      return 'assets/layout/images/gymSupplimentAvatar.png';
    }
    // If it's already a full URL or base64, return as is
    if (imagePath.startsWith('http') || imagePath.startsWith('data:image')) {
      return imagePath;
    }
    // If it's a default placeholder, return as is
    if (imagePath.includes('gymSupplimentAvatar.png') || (imagePath.includes('assets/layout/images') && !imagePath.includes('company_'))) {
      return imagePath;
    }
    // Refresh config path from localStorage
    this.config.productImagePath = localStorage?.getItem('productImagePath');
    // If productImagePath is not set, try to construct it from user data
    if (!this.config.productImagePath && this.user) {
      this.config.productImagePath = `assets/layout/images/company_${this.user.company}/branch_${this.user.branch}/products/`;
    }
    if (this.config.productImagePath && this.config.Server) {
      // Ensure no double slashes
      const basePath = this.config.Server.endsWith('/') ? this.config.Server.slice(0, -1) : this.config.Server;
      return basePath + '/' + this.config.productImagePath + imagePath;
    }
    return 'assets/layout/images/gymSupplimentAvatar.png';
  }

  onProductRowSelect(event, productsPanel: OverlayPanel) {
    this.getProducts();
    const check = this.orderProduct.filter(x => x.code === event.data.code);
    if (check.length > 0 && event.data.type != "Ingredients Based") {
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Warning Message', detail: 'Product Already Added' });
    } else {
      if (event.data.totalQuantity == 0 && event.data.type != "Ingredients Based") {
        this.messageService.clear();
        this.messageService.add({ severity: 'warn', summary: 'Warning Message', detail: 'You have no Stock of this product' });
      return;}
      if (event.data.type == "Ingredients Based") {
        this.addIngredients(event.data.ingredients);
        if (!this.checkIngredientsEnough(this.totalIngredients)) {
          this.messageService.clear();
          this.messageService.add({ severity: 'warn', summary: 'Warning Message', detail: 'Ingredients for this product are not enough.' });
          this.areIngredientsEnough = false;
          return;
        }
        else {
          this.extraIngredientsDialogVisibility = true;
          this.ingredients = [...event.data.ingredients];
        }
      }
      this.initializeIngredientsEnoughArray();
      const productToBeSale = new IProduct();
      productToBeSale._id = event.data._id;
      productToBeSale.name = event.data.name;
      productToBeSale.code = event.data.code;
      productToBeSale.type = event.data.type;
      productToBeSale.quantity = 1;
      productToBeSale.totalQuantity = event.data.totalQuantity;
      productToBeSale.unitPrice = event.data.normalPrice ? event.data.normalPrice : 1;
      productToBeSale.subTotal = productToBeSale.quantity * productToBeSale.unitPrice;
      productToBeSale.discount = 0;
      productToBeSale.gstOnProduct = event.data.gstOnProduct;
      productToBeSale.vatTax = Math.round(productToBeSale.subTotal * (event.data.gstOnProduct / 100));
      productToBeSale.category = event.data.category;
      if (event.data.type == "Ingredients Based") {
        this.getMaximumQuantity(this.totalIngredients);
      }
      const products = [...this.orderProduct];
      products.push(productToBeSale);
      this.orderProduct = products;
      productsPanel.hide();
      this.sum();
      this.index = this.orderProduct.length - 1;
      this.enterSteps = [
        "rowQuantity-" + this.index,
        "rowUnitPrice-" + this.index,
        "rowDiscount-" + this.index,
      ];
      setTimeout(() => {
        document.getElementById(this.enterSteps[0]).focus()
        this.currentStep = 0;

      }, 500);
    }
  }
  addIngredients(ingredients) {
    if (this.totalIngredients.length == 0) {
      this.totalIngredients = ingredients.map(({ code, name, quantity }) => ({ code, name, quantity }));
      return;
    } else {
      for (const ingredient of ingredients) {
        const existingIngredient = this.totalIngredients.find(x => x.code === ingredient.code);

        if (existingIngredient) {
          // Update the quantity if the ingredient already exists
          existingIngredient.quantity += ingredient.quantity;
        } else {
          // Add the ingredient if it doesn't exist in totalIngredients
          this.totalIngredients.push({ ...ingredient });
        }
      }
    }
  }
  addSingleIngredient(code, baseQuantity) {
    const existingIngredient = this.totalIngredients.find(i => i.code === code);
    if (existingIngredient) {
      existingIngredient.quantity += baseQuantity; // Update totalQuantity
    }

  }
  subtractSingleIngredient(code, baseQuantity) {
    const existingIngredient = this.totalIngredients.find(i => i.code === code);
    if (existingIngredient) {
      existingIngredient.quantity = existingIngredient.quantity - baseQuantity; // Update totalQuantity
    }

  }

  checkIngredientsEnough(ingredients) {
    let returnValue = true;
    ingredients.map(ingredient => {
      const orgIng = this.sourceProducts.filter(i => i.code == ingredient.code)[0];
      if (orgIng != null) {
        if (orgIng.totalQuantity < ingredient.quantity) {
          returnValue = false;
          return;
        }
      }
    });
    return returnValue;
  }
  checkSingleIngredientsEnough(ingredient) {
    let returnValue = true;
    const orgIng = this.sourceProducts.filter(i => i.code == ingredient.code)[0];
    this.individualMax = orgIng.totalQuantity;
    if (orgIng != null) {
      if (orgIng.totalQuantity < ingredient.quantity) {
        returnValue = false;
        return;
      }
    }
    return returnValue;
  }
  onMemberRowSelect(event, productsPanel: OverlayPanel) {
    this.selectedMember = event.data;
    this.selectedEmployee = undefined;
    this.memberName = event.data.name;
    this.buyerSearchText = event.data.name;
    this.applySoldToFromBuyer();
    productsPanel.hide();
  }

  openEmployeePanel(event, overlay: OverlayPanel) {
    const selectedName = this.selectedEmployee?.name;
    if (!this.buyerSearchText || this.buyerSearchText === selectedName) {
      this.employeesInPanel = [...this.employees];
    }
    this.first = 0;
    overlay.toggle(event);
  }

  searchPanelEmployee(event, value, type) {
    if (!(event.keyCode == 40 || event.keyCode == 38)) {
      let matchedName = [];
      if (value !== null && value !== undefined && value.toString().length > 0) {
        if (value == "" || !value) {
          this.employeesInPanel = Object.assign([], this.employees);
        } else {
          if (type === "name") {
            const search = value.toString().toLowerCase();
            matchedName = Object.assign([], this.employees).filter(emp =>
              (emp.name ? emp.name.toString().toLowerCase().indexOf(search) > -1 : false) ||
              (emp.userCode != null && emp.userCode !== undefined
                ? emp.userCode.toString().toLowerCase().indexOf(search) > -1 : false) ||
              (emp.email ? emp.email.toString().toLowerCase().indexOf(search) > -1 : false) ||
              (emp.phone ? emp.phone.toString().toLowerCase().indexOf(search) > -1 : false));
          }
          const distinct = (val, index, self) => self.indexOf(val) === index;
          this.employeesInPanel = matchedName.filter(distinct);
          if (this.employeesInPanel.length === 0) {
            this.employeesInPanel = [];
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Employees Found' });
          } else {
            this.first = 0;
            this.rowIndex = -1;
            this.employeesInPanel = [...this.employeesInPanel];
          }
        }
      } else {
        this.employeesInPanel = Object.assign([], this.employees);
        this.employeesInPanel = [...this.employeesInPanel];
      }
    }
  }

  onEmployeeRowSelect(event, productsPanel: OverlayPanel) {
    this.selectedEmployee = event.data;
    this.selectedMember = undefined;
    this.memberName = event.data.name;
    this.buyerSearchText = event.data.name;
    this.applySoldToFromBuyer();
    productsPanel.hide();
  }


  increaseQuantity(ingredient, index) {
    let existingIngredient;
    let check;
    if (this.totalIngredients.length != 0) {
      existingIngredient = this.totalIngredients.find(i => i.code === ingredient.code);
      check = this.checkSingleIngredientsEnough(existingIngredient);
    } else {
      check = this.checkSingleIngredientsEnough(ingredient);
    }
    let basePrice = 0;
    if (check) {
      if (ingredient.quantity < this.individualMax) {
        this.addSingleIngredient(ingredient.code, ingredient.baseQuantity);
        ingredient.quantity = ingredient.quantity + ingredient.baseQuantity;
        this.newSaleOrder.remainingSubtotal += ingredient.basePrice;
        if (this.orderProduct.length >= 1) {
          basePrice = this.orderProduct[this.index].unitPrice;
        }
        this.newSaleOrder.subTotal += ingredient.basePrice;
        basePrice += ingredient.basePrice;
        this.orderProduct[this.index].subTotal = basePrice;
        this.orderProduct[this.index].unitPrice = basePrice;
        this.newSaleOrder.total = Math.round(this.newSaleOrder.remainingSubtotal + this.newSaleOrder.vatTax);

      }
    } else {
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Warning Message', detail: 'Ingredients for this product are not enough.' });
      this.areIngredientsEnoughArray[index] = false;
      return;
    }
  }

  decreaseQuantity(ingredient, index) {
    if (this.areIngredientsEnoughArray[index] == false) {
      ingredient.quantity = ingredient.quantity - ingredient.baseQuantity;
    }
    this.subtractSingleIngredient(ingredient.code, ingredient.baseQuantity);
    if (this.areIngredientsEnoughArray[index] == true) {
      ingredient.quantity = ingredient.quantity - ingredient.baseQuantity;
      this.newSaleOrder.remainingSubtotal = this.newSaleOrder.remainingSubtotal - ingredient.basePrice;
      this.newSaleOrder.subTotal = this.newSaleOrder.subTotal - ingredient.basePrice;
      this.orderProduct[this.index].subTotal = this.orderProduct[this.index].subTotal - ingredient.basePrice;
      this.orderProduct[this.index].unitPrice = this.orderProduct[this.index].unitPrice - ingredient.basePrice;
      this.newSaleOrder.total = this.newSaleOrder.total - ingredient.basePrice;
    }
    this.areIngredientsEnoughArray[index] = true;

  }
  removeSelectedProduct(product) {
    this.getProducts();
    this.totalIngredients = [];
    this.ingredients = [];
    const products = [...this.orderProduct];
    const index = this.orderProduct.indexOf(product);
    if (index > -1) {
      products.splice(index, 1);
      this.isDisableSalesOrder = false;
      this.orderProduct = products;
      this.sum();
      this.index = this.orderProduct.length - 1;
      this.enterSteps = [
        "rowQuantity-" + this.index,
        "rowUnitPrice-" + this.index,
        "rowDiscount-" + this.index,
      ];

      setTimeout(() => {
        if (this.orderProduct.length > 0) {
          document.getElementById(this.enterSteps[0]).focus()
          this.currentStep = 0;
        }
      }, 300);
    }
    if (this.orderProduct.length == 0) {
      this.suspendSale();
    }
  }
  priceQuantityAndDiscountEvent(product, type) {
    let num = 0;
    if (type === "quantity" || type === "price" || type === "discount") {
      num = product.unitPrice * product.quantity;
      product.vatTax = Math.round(num * (product.gstOnProduct / 100));
      num = num - product.discount;
      product.subTotal = Math.round(num);
      const index = this.orderProduct.indexOf(product);
      this.orderProduct[index] = product;
      this.sum();
    }
  }

  sum() {
    this.newSaleOrder.subTotal = 0;
    this.newSaleOrder.total = 0;
    this.newSaleOrder.returned = 0;
    this.newSaleOrder.vatTax = 0;
    this.newSaleOrder.remainingSubtotal = 0;

    this.orderProduct.forEach(product => {
      this.newSaleOrder.subTotal = this.newSaleOrder.subTotal + product.subTotal;
      this.newSaleOrder.subTotal = Math.round(this.newSaleOrder.subTotal);
      this.newSaleOrder.vatTax = Math.round(this.newSaleOrder.vatTax + product.vatTax);
      const taxResult = this.calculateTax(
        this.newSaleOrder.subTotal,
        this.newSaleOrder.discount || 0,
        this.taxRate,
        this.taxType,
        this.isDiscountFormulaReverse,
        this.paymentModeTaxPos,
        this.orderProduct.reduce((s, p) => s + p.vatTax, 0)
      );

        this.newSaleOrder.vatTax = Math.round(taxResult.tax);
    });
    this.newSaleOrder.remainingSubtotal = Math.round(this.newSaleOrder.subTotal - (this.newSaleOrder.discount ? this.newSaleOrder.discount : 0));
    this.newSaleOrder.total = Math.round(this.newSaleOrder.remainingSubtotal + this.newSaleOrder.vatTax);

    if (isNaN(Number(this.newSaleOrder.paid))) {
      this.newSaleOrder.paid = 0;
    }
    this.calculateBalance(this.getReceivedAmount());
  }

  getReceivedAmount() {
    if (this.mode === 'edit' && this.hasOpenPayLater()) {
      return Number(this.payRemainingBalance) || 0;
    }
    return Number(this.newSaleOrder.paid) || 0;
  }

  getMaximumQuantity(productIngredients) {
    const quantityArray = [];

    this.sourceProducts.forEach((sourceProduct) => {
      const correspondingIngredient = productIngredients.find((ingredient) => ingredient.code === sourceProduct.code);

      if (correspondingIngredient) {
        quantityArray.push(sourceProduct.totalQuantity / correspondingIngredient.quantity);
      }
    });

    if (quantityArray.length > 0) {
      console.log(quantityArray);
      this.minValue = Math.min(...quantityArray);
    } else {
      // Handle the case where there are no matching elements
      this.minValue = undefined; // or any other value that makes sense in your context
    }
  }


  onOverallDiscountChange() {
    this.newSaleOrder.remainingSubtotal = 0;
    this.newSaleOrder.total = 0;
    this.newSaleOrder.discount = this.newSaleOrder.discount ? this.newSaleOrder.discount : 0;
    this.newSaleOrder.subTotal = this.newSaleOrder.subTotal ? this.newSaleOrder.subTotal : 0;
    // if (this.isPercentage) {
    //   this.newSaleOrder.remainingSubtotal = this.newSaleOrder.subTotal - (this.newSaleOrder.subTotal * this.newSaleOrder.discount / 100);
    // } else {
    this.newSaleOrder.remainingSubtotal = this.newSaleOrder.subTotal - this.newSaleOrder.discount;
    // }
    this.newSaleOrder.remainingSubtotal = Math.round(this.newSaleOrder.remainingSubtotal);
      const taxResult = this.calculateTax(
        this.newSaleOrder.subTotal,
        this.newSaleOrder.discount || 0,
        this.taxRate,
        this.taxType,
        this.isDiscountFormulaReverse,
        this.paymentModeTaxPos,
        this.orderProduct.reduce((s, p) => s + p.vatTax, 0)
      );

        this.newSaleOrder.vatTax = Math.round(taxResult.tax);
        this.newSaleOrder.total = Math.round(taxResult.total);
    this.calculateBalance(this.getReceivedAmount());

  }

  calculateBalance(Amount) {
      Amount = Number(Amount) || 0;
      if (this.mode == "add") {
          const returned = Amount - this.newSaleOrder.total;
          returned > 0? (this.newSaleOrder.returned = returned): (this.newSaleOrder.returned = 0);
          this.newSaleOrder.returned = Math.round(this.newSaleOrder.returned);
      } else if (this.hasOpenPayLater()) {
          const due = this.getPayLaterAmountDue();
          const returned = Amount - due;
          this.newSaleOrder.returned = returned > 0 ? Math.round(returned) : 0;
      } else {
        const returned = Amount - this.newSaleOrder.remainingBalance;
        returned > 0? (this.newSaleOrder.returned = returned): (this.newSaleOrder.returned = 0);
      }
      this.calculateRemainingBalance(Amount);
  }
  calculateRemainingBalance(Amount) {
    if (this.mode == "add") {
      this.newSaleOrder.total - Amount > 0 ? this.remainingBalance = this.newSaleOrder.total - Amount : this.remainingBalance = 0;
      this.remainingBalance = Math.round(this.remainingBalance);
    } else if (this.hasOpenPayLater()) {
      const due = this.getPayLaterAmountDue();
      this.remainingBalance = due - Amount > 0 ? Math.round(due - Amount) : 0;
    } else {
      this.newSaleOrder.remainingBalance - Amount > 0 ? this.remainingBalance = this.newSaleOrder.remainingBalance - Amount : this.remainingBalance = 0;
    }
  }

  suspendSale() {
    this.isDisableSalesOrder = false;
    this.newSaleOrder = new SaleOrder();
    this.paymentMode = "Cash-Reception";
    this.newSaleOrder.modeOfPayment = this.paymentMode;
    this.newSaleOrder.subTotal = 0;
    this.newSaleOrder.total = 0;
    this.newSaleOrder.discount = 0;
    this.newSaleOrder.paid = 0;
    this.newSaleOrder.returned = 0;
    this.newSaleOrder.vatTax = 0;
    this.newSaleOrder.remainingSubtotal = 0;
    this.remainingBalance = 0;
    this.payRemainingBalance = 0;
    this.buyerSearchText = '';
    this.buyerType = 'WalkIn';
    this.selectedMember = undefined;
    this.selectedEmployee = undefined;
    this.orderProduct = [];
    this.newSaleOrder.deliveryContactDetails = new IDeliveryContact();
    this.newSaleOrder.deliveryContactDetails.deliveryAddress = new IDeliveryAddress();
    this.orderStatus = null;
    this.isQuotation= false;
    this.resetSoldTo();
  }

  ProductQuantityChange(v, p) {
    let quantityCheck = true;
    if (p.type == "Ingredients Based") {
      const upgradedIngredients = this.ingredients.map((ingredient) => {
        return {
          ...ingredient,
          quantity: v < p.quantity ? ingredient.quantity / p.quantity * v : ingredient.quantity * v
        };
      });
      this.totalIngredients = upgradedIngredients;
      quantityCheck = this.checkIngredientsEnough(upgradedIngredients);
    }
    // p.quantity = p.quantity -1;

    if (v < 1) {
      this.messageService.clear();
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning Message',
        detail: 'Minimum value should be 1'
      });
      p.quantity = 1;
    }
    // Prevent quantity > available stock
    else if (v > p.totalQuantity) {
      this.messageService.clear();
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: `Only ${p.totalQuantity} items are in stock.`
      });

      setTimeout(() => {
        p.quantity = p.totalQuantity;
        this.priceQuantityAndDiscountEvent(p, "quantity");
      }, 0);

      return;
    }

    // Normal quantity update
    else {
      p.quantity = v;
    }
    this.priceQuantityAndDiscountEvent(p, "quantity");
    if (!quantityCheck) {
      this.messageService.clear();
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning Message',
        detail: 'Ingredients for this product are finished.'
      });
    }
  }

  checkOut() {
    if (this.mode === 'add' && !this.isBuyerSelected()) {
      this.messageService.clear();
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning Message',
        detail: 'Please select a buyer'
      });
      return;
    }

    if (this.mode === 'edit' && this.hasOpenPayLater()) {
      this.settlePayLater();
      return;
    }

    const isPayLaterCreate = this.mode === 'add' && this.isPayLaterMode() && !this.isQuotation;

    if (isPayLaterCreate && this.buyerType === 'WalkIn') {
      this.messageService.clear();
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning Message',
        detail: 'Please select a customer or employee for Pay Later'
      });
      return;
    }

    if (isPayLaterCreate && !this.getSelectedBuyer()) {
      this.messageService.clear();
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning Message',
        detail: 'Please select a customer or employee for Pay Later'
      });
      return;
    }

    if (!isPayLaterCreate && this.mode === 'add' && !this.isQuotation && this.newSaleOrder.paid === 0 && this.newSaleOrder.total > 0) {
      this.messageService.clear();
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning Message',
        detail: 'Payment received should not be zero'
      });
      return;
    }

    if (!isPayLaterCreate && this.mode === 'add' && !this.isQuotation && this.newSaleOrder.paid > 0 && this.newSaleOrder.paid < this.newSaleOrder.total) {
      this.messageService.clear();
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning Message',
        detail: 'Payment received should not be less than Grand Total'
      });
      return;
    }

    this.openConfirmationDialog("Are you sure you want to proceed?", () => {
        const user = JSON.parse(localStorage.getItem("currentUser"));
        this.newSaleOrder.company = user.company;
        this.newSaleOrder.branch = user.branch;
        this.newSaleOrder.createdBy = this.user.name;
        this.newSaleOrder.remainingBalance = this.remainingBalance;
        if(this.mode=="edit"){
          this.newSaleOrder.paid = this.payRemainingBalance;
        }
        if (this.buyerType === 'WalkIn' || this.getSelectedBuyer()) {
          this.applySoldToFromBuyer();
        }
        else if (this.selectedMember) {
          this.newSaleOrder.soldTo.name = this.selectedMember.name;
          this.newSaleOrder.soldTo.tagNumber = this.selectedMember.tagNumber;
          this.newSaleOrder.soldTo._id = this.selectedMember._id;
          this.newSaleOrder.soldTo.type = 'Customer';
        }
        else {
          if (!this.newSaleOrder.soldTo) {
            this.newSaleOrder.soldTo = new SoldTo();
          }
          this.newSaleOrder.soldTo.name = this.memberName;
          this.newSaleOrder.soldTo.type = 'WalkIn';
        }

        if (isPayLaterCreate) {
          this.newSaleOrder.paid = 0;
          this.newSaleOrder.remainingBalance = 0;
          this.newSaleOrder.returned = 0;
          this.newSaleOrder.modeOfPayment = 'Pay-Later';
          this.newSaleOrder.orderStatus = 'payLater';
          this.newSaleOrder.payLater = this.buildPayLaterObject();
          // Keep Sold To in sync with Pay Later buyer
          if (this.newSaleOrder.payLater?.buyerName) {
            if (!this.newSaleOrder.soldTo) {
              this.newSaleOrder.soldTo = new SoldTo();
            }
            this.newSaleOrder.soldTo.name = this.newSaleOrder.payLater.buyerName;
            this.newSaleOrder.soldTo.type = this.newSaleOrder.payLater.buyerType;
            this.newSaleOrder.soldTo._id = this.newSaleOrder.payLater.buyerId;
            if (this.newSaleOrder.payLater.tagNumber) {
              this.newSaleOrder.soldTo.tagNumber = this.newSaleOrder.payLater.tagNumber;
            }
            if (this.newSaleOrder.payLater.employeeCode != null) {
              this.newSaleOrder.soldTo.employeeCode = String(this.newSaleOrder.payLater.employeeCode);
            }
            this.memberName = this.newSaleOrder.payLater.buyerName;
          }
        }

        this.newSaleOrder.status = "POS"
        this.newSaleOrder.modeOfPayment = this.newSaleOrder.modeOfPayment || this.paymentMode || "Cash-Reception";
        this.orderProduct.forEach((product) => {
          product.discount = parseInt(product.discount.toString());
          if (product.type != "Ingredients Based") {
            product.totalQuantity = product.totalQuantity - product.soldQuantity;
          }
          product.lastSoldPrice = product.unitPrice;
          product.SaleOrderProductLastQuantity = product.quantity;
          product.isSaleOrderQuantityChange = false;
          product.isNewItemInSaleOrder = true;
        });
        this.newSaleOrder.products = this.orderProduct;
        this.newSaleOrder.type = this.newSaleOrder.type || 'POS';
        if (this.isQuotation && this.mode == "add") {
          this.newSaleOrder.orderStatus = 'quotation';
        } else if (isPayLaterCreate) {
          this.newSaleOrder.orderStatus = 'payLater';
        } else if (this.mode == "add") {
          this.newSaleOrder.orderStatus = 'fulfilled';
        }
        const branchId = AuthService.getLoggedInBranch() || user.branch;
        this.appServiceManager.post(
          `branches/${branchId}/sale-orders`,
          buildSaleOrderCreatePayload(this.newSaleOrder, this.orderProduct, {
            company: user.company,
            branch: branchId,
          }),
        ).subscribe((res: any) => {
          if (res?.status === false) {
            this.messageService.clear();
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: res.error || 'Something Went Wrong',
            });
            return;
          }
          if (res?.saleorder) {
            this.newSaleOrder = res.saleorder;
            this.getProducts()
            this.orderProduct = [];
            setTimeout(() => {
              this.printSaleInvoice();
              this.suspendSale();
              document.getElementById("suspendButton").focus();
            }, 300);
            this.isDisableSalesOrder = true;
            this.messageService.clear();
            if( this.isQuotation && this.mode=="add"){
              this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Quotation Created Successfully' });
            }else this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'CheckOut Successfully' });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
        },
          (error) => {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
    });
  }

  settlePayLater() {
    if (!this.newSaleOrder.payLater) {
      return;
    }
    const amountDue = this.getPayLaterAmountDue();
    const received = Number(this.payRemainingBalance) || 0;
    if (!this.paymentMode || this.paymentMode === 'Pay-Later') {
      this.messageService.clear();
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning Message',
        detail: 'Please select a payment mode to settle Pay Later'
      });
      return;
    }

    if (received === 0 && amountDue > 0) {
      this.messageService.clear();
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning Message',
        detail: 'Payment received should not be zero'
      });
      return;
    }

    if (received < amountDue) {
      this.messageService.clear();
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning Message',
        detail: 'Payment received should not be less than Grand Total'
      });
      return;
    }

    const returned = received > amountDue ? Math.round(received - amountDue) : 0;
    this.newSaleOrder.returned = returned;

    this.openConfirmationDialog(`Pay ${amountDue} for this Pay Later order?`, () => {
        const branchId = AuthService.getLoggedInBranch() || this.user.branch;
        const payload = {
          paid: received,
          returned: returned,
          modeOfPayment: this.paymentMode,
        };
        this.loading = true;
        this.appServiceManager.put(
          `branches/${branchId}/sale-orders/${this.saleOrderId}/pay-later`,
          payload,
        ).subscribe(
          (res: any) => {
            if (res?.status === false) {
              this.loading = false;
              this.messageService.clear();
              this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: res.error || 'Something Went Wrong',
              });
              return;
            }

            // Re-fetch order — local tweaks are not enough; DB must be fulfilled
            this.appServiceManager.get(
              `branches/${branchId}/sale-orders/${this.saleOrderId}`,
            ).subscribe(
              (order: any) => {
                this.loading = false;
                const paid = Number(order?.paid) || 0;
                const stillOpen =
                  order?.orderStatus === 'payLater' ||
                  (!!order?.payLater && paid < amountDue);

                if (stillOpen) {
                  this.messageService.clear();
                  this.messageService.add({
                    severity: 'error',
                    summary: 'Settle incomplete on server',
                    detail:
                      `Pay Later API did not close this order (orderStatus=${order?.orderStatus || 'n/a'}, paid=${paid}). ` +
                      'Backend must set orderStatus to "fulfilled", set paid, and remove payLater on settle.',
                  });
                  return;
                }

                this.newSaleOrder = order;
                this.messageService.clear();
                this.messageService.add({
                  severity: 'success',
                  summary: 'Success Message',
                  detail: 'Pay Later settled successfully',
                });
                this.router.navigate(['/sale-orders'], {
                  queryParams: { filter: 'All', t: Date.now() },
                });
              },
              (error) => {
                this.loading = false;
                this.messageService.clear();
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error Message',
                  detail: error.error?.message || error,
                });
              },
            );
          },
          (error) => {
            this.loading = false;
            this.messageService.clear();
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: error.error?.message || error.message || error,
            });
          },
        );
    });
  }

  closeExtraIngredientsDialog() {
    this.extraIngredientsDialogVisibility = false;
    this.getMaximumQuantity(this.totalIngredients);
    this.orderProduct[this.index].ingredients = this.ingredients;
  }

  checkOutWithDeliveryOptions() {
    if (this.mode === 'add' && !this.isBuyerSelected()) {
      this.messageService.clear();
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning Message',
        detail: 'Please select a buyer'
      });
      return;
    }
    this.openConfirmationDialog("Are you sure you want to proceed?", () => {
        const user = JSON.parse(localStorage.getItem("currentUser"));
        this.newSaleOrder.company = user.company;
        this.newSaleOrder.branch = user.branch;
        this.newSaleOrder.createdBy = this.user.name;
        if (this.buyerType === 'WalkIn' || this.getSelectedBuyer()) {
          this.applySoldToFromBuyer();
        }
        this.orderProduct.forEach((product) => {
          product.discount = parseInt(product.discount.toString());
          product.totalQuantity = product.totalQuantity - product.soldQuantity;
          product.lastSoldPrice = product.unitPrice;
          product.SaleOrderProductLastQuantity = product.quantity;
          product.isSaleOrderQuantityChange = false;
          product.isNewItemInSaleOrder = true;
        });

        this.newSaleOrder.products = this.orderProduct;
        this.appServiceManager.post("products/salesOrderWithDeliveryOptions", this.newSaleOrder).subscribe((res: any) => {
          if (res) {
            this.newSaleOrder = res.saleorder;
            this.getProducts()
            setTimeout(() => {
              this.printSaleInvoice();
              this.suspendSale();
              document.getElementById("suspendButton").focus();
            }, 300);
            this.isDisableSalesOrder = true;
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'CheckOut Successfully' });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
        },
          (error) => {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
    });
  }

  printSaleInvoice(): void {
    let printContents, popupWin;
    printContents = document.getElementById("salesInvoice").innerHTML;
    popupWin = window.open(
      "",
      "_blank",
      "top=0,left=0,height=100%,width=auto"
    );
    popupWin.document.open();
    popupWin.document.write(`
      <html>
      <head>
        <title>Gym Invoice</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: top;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }

            .invoice-box table tr.top table td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.information table td {
                padding-bottom: 40px;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
      </head>
      <body>${printContents}</body>
      </html>
    `);
  }

  addProductThroughBarcodeScanner(barcode) {
    this.keyBuffer = [];
    let barcodeMatchedProductObject = this.Products.find(x => x.barcode == barcode);
    let check = this.orderProduct.filter(x => x.code === barcodeMatchedProductObject.code);
    if (check.length > 0) {
      this.orderProduct[this.orderProduct.indexOf(check[0])].quantity = this.orderProduct[this.orderProduct.indexOf(check[0])].quantity + 1;
      this.orderProduct[this.orderProduct.indexOf(check[0])].subTotal = this.orderProduct[this.orderProduct.indexOf(check[0])].quantity * this.orderProduct[this.orderProduct.indexOf(check[0])].unitPrice;
      this.orderProduct[this.orderProduct.indexOf(check[0])].discount = 0;
      this.orderProduct[this.orderProduct.indexOf(check[0])].vatTax = Math.round(this.orderProduct[this.orderProduct.indexOf(check[0])].subTotal * (this.orderProduct[this.orderProduct.indexOf(check[0])].gstOnProduct / 100));
      this.sum();

    } else {
      let productToBeSale = new IProduct();
      productToBeSale._id = barcodeMatchedProductObject._id;
      productToBeSale.name = barcodeMatchedProductObject.name;
      productToBeSale.code = barcodeMatchedProductObject.code;
      productToBeSale.quantity = 1;
      productToBeSale.totalQuantity = barcodeMatchedProductObject.totalQuantity;
      productToBeSale.unitPrice = barcodeMatchedProductObject.normalPrice ? barcodeMatchedProductObject.normalPrice : 1;
      productToBeSale.subTotal = productToBeSale.quantity * productToBeSale.unitPrice;
      productToBeSale.discount = 0;
      productToBeSale.type = barcodeMatchedProductObject.type;
      productToBeSale.category = barcodeMatchedProductObject.category;
      productToBeSale.gstOnProduct = barcodeMatchedProductObject.gstOnProduct;
      productToBeSale.vatTax = Math.round(productToBeSale.subTotal * (barcodeMatchedProductObject.gstOnProduct / 100));
      let products = [...this.orderProduct];
      products.push(productToBeSale);
      this.orderProduct = products;
      this.sum();
      this.index = this.orderProduct.length - 1;
      this.enterSteps = [
        "rowQuantity-" + this.index,
        "rowUnitPrice-" + this.index,
        "rowDiscount-" + this.index,
      ];

    }

  }

  disableAlphaNum(e) {
    var charCode = (e.which) ? e.which : e.keyCode;
    if (charCode >= 48 && charCode <= 57) {
      e.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  detectDiscountEvent(event, product) {
    if (event.currentTarget.value <= 0) {
      event.currentTarget.value = 0;
      product.discount = 0;
      this.priceQuantityAndDiscountEvent(product, 'discount');
    } else if (event.currentTarget.value >= product.unitPrice) {
      event.currentTarget.value = 0;
      product.discount = 0;
      this.priceQuantityAndDiscountEvent(product, 'discount');

    }
  }

  hotkeys($event) {

    if (this.confirmationMessage && ($event.keyCode == 39 || $event.keyCode == 37)) {
      const confirmationButtons = document.querySelectorAll(".cd-actions .cd-action");
      if (confirmationButtons.length > 0) {
        const activeIndex = Array.from(confirmationButtons).findIndex(button => button === document.activeElement);
        confirmationButtons[activeIndex === 0 ? 1 : 0]?.focus();
      }
    }

    else if (!$event.ctrlKey && $event.keyCode == 13 && $event.code == 'NumpadEnter' && this.towardsCheckOut) {
      let nextStep = 0;
      let nextId = "";
      if (this.newSaleOrder.isDeliveryEnabled) {
        nextStep = this.summaryStepsWithDelivery.length - 1 > this.summaryCurrentStep ? this.summaryCurrentStep + 1 : 0;
        nextId = this.summaryStepsWithDelivery[nextStep];
      }
      else {
        nextStep = this.summarySteps.length - 1 > this.summaryCurrentStep ? this.summaryCurrentStep + 1 : 0;
        nextId = this.summarySteps[nextStep];
      }
      const ele: any = document.getElementById(nextId)
      if (nextId == "checkoutButton" && !(ele.disabled)) {
        ele.click();
        this.summaryCurrentStep = 0;
      } else if (nextId == "checkoutButton" && ele.disabled) {
        document.getElementById("overallDiscount").focus();
        this.summaryCurrentStep = 0;
      } else {
        ele.focus();
        this.summaryCurrentStep = nextStep;
      }
    }

    else if (!$event.ctrlKey && $event.keyCode == 13 && $event.code == 'NumpadEnter' && !this.towardsCheckOut) {
      var nextStep = this.enterSteps.length - 1 > this.currentStep ? this.currentStep + 1 : 0;
      var nextId = this.enterSteps[nextStep];
      let ele: any = document.getElementById(nextId)
      ele.focus();
      this.currentStep = nextStep;
    }

    else if ($event.ctrlKey && $event.keyCode == 13 && $event.code == 'NumpadEnter' && !($event.target.tagName == 'BODY')) {
      let ele: any = document.getElementById("overallDiscount");
      ele.focus();
      this.towardsCheckOut = true;
    }

    else if ($event.keyCode == 115) {
      this.searchProductInput.nativeElement.focus();
      this.searchProductInput.nativeElement.click();

    }
    else if ($event.keyCode == 113) {
      this.searchMemberInput.nativeElement.focus();
      this.searchMemberInput.nativeElement.click();

    }

    else if ($event.keyCode == 119 && this.mode == 'add') {
      this.newSaleOrder.isDeliveryEnabled = !this.newSaleOrder.isDeliveryEnabled;
      if (this.newSaleOrder.isDeliveryEnabled) {
        document.getElementById("deliveryFirstName").focus();
        this.summaryCurrentStep = 0;
      } else {
        document.getElementById("overallDiscount").focus();
        this.currentStep = 0;
      }
    }

    else if ($event.keyCode == 40) {
      if (this.gridViewData.overlayVisible == true) {
        this.rowIndex++;
        //move to next page
        if (this.rowIndex > this.productsInPanel.length - 1) {
          // if (this.rowIndex + 1 > ((pageIndex - 1) * this.dataTable.rows) + 10) {
          //     this.setCurrentPage(pageIndex + 1);
          // }
        }
        if (this.productsInPanel != undefined)
          this.selectProduct = this.productsInPanel[this.rowIndex];
      }
    }

    else if ($event.keyCode == 38) {
      this.rowIndex--;
      this.rowIndex = this.rowIndex < 0 ? 0 : this.rowIndex;
      //move back to previous page
      // if (this.rowIndex < ((pageIndex - 1) * this.dataTable.rows)) {
      //     this.setCurrentPage(pageIndex - 1);
      // }
      if (this.productsInPanel != undefined) {

        this.selectProduct = this.productsInPanel[this.rowIndex];
      }
    }

    else if ($event.keyCode == 13 && this.gridViewData.overlayVisible) {
      if (this.selectProduct) {
        var tempEvent: any = {};
        tempEvent.data = JSON.parse(JSON.stringify(this.selectProduct));
        this.onProductRowSelect(tempEvent, this.gridViewData)
        this.selectProduct = undefined;
        this.rowIndex = -1;
        // this.setCurrentPage(1);
      } else {
        this.rowIndex = 0;
        if (this.productsInPanel != undefined) {
          this.selectProduct = this.productsInPanel[0];
        }
      }
    }

    else if ($event.which === 13 && $event.target.tagName == 'BODY') {
      let barcode = this.keyBuffer.join("")
      console.log("BarCode Completed:", barcode);

      if (barcode.length > 0) {
        this.addProductThroughBarcodeScanner(barcode);
        this.keyBuffer = [];
      }
    }

    var number = $event.which - 48;
    if (number < 0 || number > 9) {
      return;
    }
    this.keyBuffer.push(number);
  }

  hotClick($event) {
    let currentClickLocation = $event.target.id;
    let isSummaryStepsWithDelivery = this.summaryStepsWithDelivery.filter(x => x === currentClickLocation).length > 0;
    let isSummarySteps = this.summarySteps.filter(x => x === currentClickLocation).length > 0;
    let isEnterSteps = this.enterSteps && this.enterSteps.filter(x => x === currentClickLocation).length > 0;
    if (isSummaryStepsWithDelivery) {
      let indexOfClickField = this.summaryStepsWithDelivery.indexOf(currentClickLocation);
      if (indexOfClickField !== -1) {
        this.summaryCurrentStep = indexOfClickField;
      } else {
        this.summaryCurrentStep = this.summaryCurrentStep;
      }
      this.towardsCheckOut = true;
    }
    if (isSummarySteps && !isSummaryStepsWithDelivery) {
      let indexOfClickField = this.summarySteps.indexOf(currentClickLocation);
      if (indexOfClickField !== -1) {
        this.summaryCurrentStep = indexOfClickField;
      } else {
        this.summaryCurrentStep = this.summaryCurrentStep;
      }
      this.towardsCheckOut = true;
    }
    if (isEnterSteps && this.orderProduct.length > 0) {
      let indexOfClickField = this.enterSteps.indexOf(currentClickLocation);
      if (indexOfClickField !== -1) {
        this.currentStep = indexOfClickField;
      } else {
        this.currentStep = this.currentStep;
      }
      this.towardsCheckOut = false;
      this.summaryCurrentStep = 0;
    }
  }

  handleSwitchChange(e) {
    if (e.checked) {
      document.getElementById("deliveryFirstName").focus();
      this.summaryCurrentStep = 0;
    } else {
      document.getElementById("overallDiscount").focus();
      this.summaryCurrentStep = 0;
    }
  }

  changeDeliveryStatus() {
    this.openConfirmationDialog("Are you sure you want to change status?", () => {
        let data = {
          status: this.newSaleOrder.status == 'REQUESTED' ? 'CONFIRMED'
            : this.newSaleOrder.status == 'CONFIRMED' ? 'READY_TO_SHIPPED'
              : this.newSaleOrder.status == 'READY_TO_SHIPPED' ? 'SHIPPED'
                : 'DELIVERED',
          modifiedBy: this.user._id
        }
        this.appServiceManager
          .put("products/changeDeliveryStatus/" + this.saleOrderId, data)
          .subscribe(
            (res: any) => {
              if (res) {
                this.newSaleOrder = res.saleOrder;
                this.getSaleOrderById();
                this.messageService.add({
                  severity: "success",
                  summary: "Success Message",
                  detail: "Status Successfully Updated",
                });
              } else {
                this.messageService.clear();
                this.messageService.add({
                  severity: "info",
                  summary: "Info Message",
                  detail: "Something Went Wrong",
                });
              }
            },
            (error) => {
              this.messageService.clear();
              this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: error,
              });
            }
          );
    });
  }

  private openConfirmationDialog(message: string, action: () => void): void {
    this.confirmationMessage = message;
    this.pendingConfirmationAction = action;
  }

  confirmPendingAction(): void {
    const action = this.pendingConfirmationAction;
    this.cancelPendingAction();
    action?.();
  }

  cancelPendingAction(): void {
    this.confirmationMessage = '';
    this.pendingConfirmationAction = null;
  }

  PriceQuantityChange(v, p) {
    p.unitPrice = v;
    this.priceQuantityAndDiscountEvent(p, "price");
  }

  DiscountQuantityChange(v, p) {
    p.discount = v;
    this.priceQuantityAndDiscountEvent(p, "discount");
  }
}
